import { captureEvent } from "../../../utils/o11y";

import { useFormulaViewerModal } from "../modals/FormulaViewer";
import type { GetContextMenuSection } from "./helpers";
import { getIcon } from "./icons";
import { useUserSubscriptionTier } from "../../../data/user";

export const useGetMenuItemsShowFormula = (): GetContextMenuSection => {
  const { disabledFeatures } = useUserSubscriptionTier();
  const modal = useFormulaViewerModal();

  return (ctx) => {
    if (!ctx.hasFormula) return [];
    return [
      {
        name: "Show Formula",
        disabled: disabledFeatures?.showFormula,
        icon: getIcon("function"),
        action: () => {
          captureEvent("viewed_formula", {
            productId: ctx.productId,
            columnId: ctx.columnId,
            rowId: ctx.rowId,
          });
          modal.open({
            selection: ctx.selectedRange,
            height: 350,
            width: 600,
          });
        },
      },
    ];
  };
};
